import { render, staticRenderFns } from "./BrandLogoSplash.vue?vue&type=template&id=51b37b2c&"
import script from "./BrandLogoSplash.vue?vue&type=script&lang=js&"
export * from "./BrandLogoSplash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports